import React, {useContext} from "react";
import HelpComponent from "components/HelpComponent";
import SelectTreeView from "components/SelectTreeView";
import FormTranslationContext from "context/FormTranslationContext";

function NoticeGlossaryInput
({
     id,
     label,
     formikProps,
     items,
     multiple,
     required,
     unmountOnExit,
     onChange,
     useObjectInsteadOfValues,
     prefixLabelsWithKeys,
     disabled,
     className
 }) {
    const {formTr, formTip} = useContext(FormTranslationContext)
    const tip = formTip(label ? label : id);

    const input = <SelectTreeView
        id={id}
        label={formTr(label ? label : id)}
        items={items}
        formikProps={formikProps}
        multiple={multiple}
        required={required}
        unmountOnExit={unmountOnExit}
        skipCheckTouched
        onChange={onChange}
        useObjectInsteadOfValues={useObjectInsteadOfValues}
        prefixLabelsWithKeys={prefixLabelsWithKeys}
        disabled={disabled}
        className={className}
    />

    if (tip)
        return <HelpComponent text={<div dangerouslySetInnerHTML={{__html: tip}}></div>}>
            {input}
        </HelpComponent>
    return input;


}

export default NoticeGlossaryInput;